module.exports = __webpack_public_path__ + "static/media/14_lampa_47.71_7.87.20d424e8.png";